<template>
  <div class="from">
    <Form ref="authenticationForm" :label-width="180" :model="formCustom">
      <div class="box">
        <div class="title">基础信息</div>
        <Form-item label="产品名称">
          <Input v-model="formCustom.companyName" :maxlength="50"
                 clearable placeholder="请输入" style="width: 350px"></Input>
        </Form-item>
        <Form-item label="产品分类">
        </Form-item>
        <Form-item label="关联功能点">
          <CheckboxGroup v-model="fruit">
            <Checkbox label="薪资发放"></Checkbox>
            <Checkbox label="个税计算"></Checkbox>
            <Checkbox label="工资单发放"></Checkbox>
          </CheckboxGroup>
        </Form-item>
        <Form-item label="服务城市">
          <el-cascader v-model="formCustom.countyCode" :options="areaData" :props="props" filterable
                       placeholder="请选择服务城市" style="width: 400px;"></el-cascader>
        </Form-item>
        <Form-item label="产品标签">
          <Input v-model="formCustom.companyName" :maxlength="50"
                 clearable placeholder="请输入产品标签" style="width: 350px"></Input>
        </Form-item>
        <Form-item label="产品概述">
          <Input v-model="formCustom.companyName" maxlength="50"
                 placeholder="请输入产品概述" type="textarea"/>
        </Form-item>
        <Form-item label="产品详情">
          <div style="border: 1px solid #ccc;">
            <Toolbar
              :defaultConfig="toolbarConfig"
              :editor="editor"
              :mode="mode"
              style="border-bottom: 1px solid #ccc"
            />
            <Editor
              v-model="html"
              :defaultConfig="editorConfig"
              :mode="mode"
              style="height: 500px; overflow-y: hidden;"
              @onCreated="onCreated"
            />
          </div>
        </Form-item>
        <Form-item label="服务资质证明">
          <el-upload
            action="https://jsonplaceholder.typicode.com/posts/"
            class="upload-demo"
            drag
            multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div slot="tip" class="el-upload__tip">只能上传pdf/jpg/png格式</div>
          </el-upload>
        </Form-item>
      </div>
      <div class="box">
        <div class="title">销售信息</div>
        <Form-item label="产品指导价格：" prop="roleName">
          <Select v-model="formCustom.employeeIsOnJob" clearable filterable placeholder="请选择计价方式"
                  style="width: 200px">
            <Option value="1">区间价格</Option>
            <Option value="0">固定价格</Option>
            <Option value="0">最低价格</Option>
            <Option value="0">面议</Option>
          </Select>
          <Input v-model="formCustom.companyName" :maxlength="50"
                 clearable placeholder="请输入价格" style="width: 350px"></Input>
          <Select v-model="formCustom.s" clearable filterable placeholder="请选择计价单位" style="width: 200px"
                  value="0">
            <Option value="0">元</Option>
            <Option value="0">元/人/年</Option>
            <Option value="0">元/人/月</Option>
          </Select>
        </Form-item>
      </div>

      <Form-item>
        <Button class="back" @click="back">返回</Button>
        <Button class="next" type="primary" @click="handleSearch">提交</Button>
      </Form-item>
    </Form>
  </div>
</template>
<script>
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'

export default ({
  name: 'addProduct',
  components: {Editor, Toolbar},
  data() {
    return {
      formCustom: {
        companyName: ''
      },
      editor: null,
      html: '',
      toolbarConfig: {},
      editorConfig: {placeholder: '请输入内容...'},
      mode: 'default',
    }
  },
  mounted() {
    setTimeout(() => {
      this.html = ''
    }, 1500)
  },
  methods: {
    back() {
      this.$router.back()
    },
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  }
})
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="less" scoped>
.from {
  .title {
    color: rgba(16, 16, 16, 1);
    font-size: 28px;
    margin-left: 250px;
    margin-bottom: 20px;
  }
}

.img {
  width: 360px;
  height: 180px;
}

.iviewButton {
  margin-right: 80px;
}

.back {
  border-radius: 4px;
  font-size: 18px;
  height: 50px;
  width: 360px;
  margin-right: 200px;
}

.next {
  border-radius: 4px;
  background-color: rgba(0, 123, 211, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  height: 50px;
  border-color: #3A62D7;
  width: 360px
}

.box {
  border: 1px #d6d6d6 solid;
  margin-bottom: 50px;
  padding-right: 500px;
  padding-top: 50px;
  padding-bottom: 50px;

}
</style>
